/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateSiteSectionDocumentRequestSiteSectionDocumentFromJSON, UpdateSiteSectionDocumentRequestSiteSectionDocumentToJSON } from './UpdateSiteSectionDocumentRequestSiteSectionDocument';
export function UpdateSiteSectionDocumentRequestFromJSON(json) {
    return UpdateSiteSectionDocumentRequestFromJSONTyped(json, false);
}
export function UpdateSiteSectionDocumentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        siteSectionDocument: !exists(json, 'site_section_document')
            ? undefined
            : UpdateSiteSectionDocumentRequestSiteSectionDocumentFromJSON(json['site_section_document'])
    };
}
export function UpdateSiteSectionDocumentRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        site_section_document: UpdateSiteSectionDocumentRequestSiteSectionDocumentToJSON(value.siteSectionDocument)
    };
}
